<div class="content-header" *ngIf="signUpMode">Create User Profile</div>
<div class="content content-with-elevation">
  <form novalidate [formGroup]="editUserProfileForm" (ngSubmit)="onSubmit()">

    <common-alerts [displayField]="false" *ngIf="error" [error]="error"></common-alerts>

    <div class="basic-details-section">
      <!--Login Name-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Login Name</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="loginName" placeholder="Login Name"
                                                          class="input-group-custom" maxlength="100" required>
          <label class="required-field">* Required Field</label>
          <lib-whitelist-character-error [whitelistFormControl]="loginName"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Email-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Email</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="email" placeholder="Email"
                                                          class="input-group-custom" maxlength="100" required>
          <label class="required-field">* Required Field</label>
        </div>
      </div>
      <!--First Name-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>First Name</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="firstName" placeholder="First Name"
                                                          class="input-group-custom" maxlength="100" required>
          <label class="required-field">* Required Field</label>
          <lib-whitelist-character-error [whitelistFormControl]="firstName"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Last Name-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Last Name</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="lastName" placeholder="Last Name"
                                                          class="input-group-custom" maxlength="100" required>
          <label class="required-field">* Required Field</label>
          <lib-whitelist-character-error [whitelistFormControl]="lastName"></lib-whitelist-character-error>
        </div>
      </div>
      <div class="text-helper" *ngIf="isTldManagerInterface() && !signUpMode">For changes to your name and email address, please contact the IANA Services Team at <a
        href="mailto:root-mgmt@iana.org">root-mgmt&#64;iana.org</a>.</div>
    </div>

    <div *ngIf="isTldManagerProfile()">
      <!--Place Of Residence-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Place Of Residence</label>
        </div>
        <div class="cell large-10 medium-6 small-6">
            <div class="cell">
              <select formControlName="residenceCountryCode" style="width: 90%"
                      aria-describedby="Select a Country" (change)="showOtherElementPlaceOfResidence()">
                <option *ngFor="let country of countries" [value]="country.countryCode"
                        [selected]="country.countryCode==this.editUserProfileForm.getRawValue().residenceCountryCode">
                  {{country.countryName}}
                </option>
              </select>
            </div>
            <div class="cell" style="margin-top: 0.5rem"><input formControlName="otherCountryPlaceOfResidence" placeholder="Other.."
                                                                *ngIf="showOtherCountryElementPlaceOfResidence"
                                                                class="input-group-custom" maxlength="20">
              <lib-whitelist-character-error [whitelistFormControl]="otherCountryPlaceOfResidence"></lib-whitelist-character-error>
            </div>
        </div>
      </div>
      <!--Organization-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Organization</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="organizationName" placeholder="Organization Name"
                                                          class="input-group-custom" maxlength="100">
          <lib-whitelist-character-error [whitelistFormControl]="organizationName"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Postal Address-->
      <div class="grid-x">
        <div class="cell large-2 medium-6 small-6"><label>Postal Address:</label></div>
        <div class="cell large-10 medium-6 small-6"><textarea formControlName="streetAddress" placeholder="Street Address"
                                                              class="input-group-custom"></textarea>
          <lib-whitelist-character-error [whitelistFormControl]="streetAddress"></lib-whitelist-character-error>
        </div>
      </div>
      <!--City-->
      <div class="grid-x">
        <div class="cell large-2 medium-6 small-6"></div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="city" placeholder="City"
                                                           class="input-group-custom" maxlength="50">
          <lib-whitelist-character-error [whitelistFormControl]="city"></lib-whitelist-character-error>
        </div>
      </div>
      <!--State-->
      <div class="grid-x">
        <div class="cell large-2 medium-6 small-6"></div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="state" placeholder="State"
                                                           class="input-group-custom" maxlength="50">
          <lib-whitelist-character-error [whitelistFormControl]="state"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Postal Code-->
      <div class="grid-x">
        <div class="cell large-2 medium-6 small-6"></div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="postalCode" placeholder="Postal Code"
                                                           class="input-group-custom" maxlength="15">
          <lib-whitelist-character-error [whitelistFormControl]="postalCode"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Country-->
      <div class="grid-x">
        <div class="cell large-2 medium-6 small-6"></div>
        <div class="cell large-10 medium-6 small-6">
            <div class="cell">
              <select formControlName="countryName" style="width: 90%"
                      aria-describedby="Select a Country" (change)="showOtherElement()">
                <option *ngFor="let country of countries" [value]="country.countryCode"
                        [selected]="country.countryCode==this.editUserProfileForm.getRawValue().countryName">
                  {{country.countryName}}
                </option>
              </select>
            </div>
            <div class="cell" style="margin-top: 0.5rem"><input formControlName="otherCountry" placeholder="Other.."
                                                                *ngIf="showOtherCountryElement"
                                                                class="input-group-custom" maxlength="20">
              <lib-whitelist-character-error [whitelistFormControl]="otherCountry"></lib-whitelist-character-error>
            </div>
        </div>
      </div>
      <!--Phone-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Phone Number</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="phone" placeholder="e.g. +5 555-555-5555"
                                                          class="input-group-custom" maxlength="40">
          <lib-whitelist-character-error [whitelistFormControl]="phone"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Mobile-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Mobile Number</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="mobile" placeholder="e.g. +5 555-555-5555"
                                                          class="input-group-custom" maxlength="40">
          <lib-whitelist-character-error [whitelistFormControl]="mobile"></lib-whitelist-character-error>
        </div>
      </div>
      <!--Fax-->
      <div class="grid-x align-center">
        <div class="cell large-2 medium-6 small-6">
          <label>Fax Number</label>
        </div>
        <div class="cell large-10 medium-6 small-6"><input formControlName="fax" placeholder="e.g. +5 555-555-5555"
                                                          class="input-group-custom" maxlength="40">
          <lib-whitelist-character-error [whitelistFormControl]="fax"></lib-whitelist-character-error>
        </div>
      </div>

      <div class="grid-x save-cancel-button-group">
        <button class="iana-button-cancel" *ngIf="!signUpMode" (click)="cancel()">Cancel</button>
        <button class="iana-button" [disabled]="!editUserProfileForm.valid" type="submit">Save</button>
      </div>
    </div>


  </form>

</div>
